module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-whyus-photo-00.jpg?h=268080d3ae3cf65d160deb91ecedce55";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-00.jpg
// module id = 2128
// module chunks = 12 15